const DOMbody = document.querySelector("body");

// Define environment-specific variables
export const baseUrl = DOMbody.getAttribute("data-baseurl"),
  assetPath = DOMbody.getAttribute("data-assetbasepath"),
  familyTreeUrl = DOMbody.getAttribute("data-familytreeurl"),
  reqUrl = DOMbody.getAttribute("data-requrl");

// Define breakpoints for different screen sizes
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};
